export default "__VITE_ASSET__DXC8w80H__"